module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [(_vm.dashboardFlags.evsensAdminFlag === false) ? _c('div', {
    staticClass: "bg-image img-rounded overflow-hidden push tesla-bg"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', {
    staticClass: "h2 font-w300 push"
  }, [_vm._v(_vm._s(_vm.labelTopPage[_vm.actualLanguage]))]), _vm._v(" "), (_vm.actualBundle.permissions.bundle[0].value) ? _c('div', {
    staticClass: "block block-rounded"
  }, [(_vm.dashboardFlags.evsensAdminFlag === false) ? _c('div', [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplaySharing === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplaySharing()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplaySharing) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplaySharing()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "h4 block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplaySharing()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.sectionLabelSharing[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplaySharing) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 push"
  }, [_c('div', [_c('p', [(_vm.bundleSharingEnableFlag) ? _c('button', {
    staticClass: "btn btn-block btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.shareMyDefaultBundle()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-share-alt fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelShareMyDefaultBundle[_vm.actualLanguage]))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('h6', {
    staticClass: "font-w200"
  }, [_vm._v(_vm._s(_vm.textSharingDetail[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 push"
  }, [_c('div', [_c('p', [(_vm.bundleSharingEnableFlag) ? _c('button', {
    staticClass: "btn btn-block btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.readGroupSharings()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-repeat fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelRefreshListSharing[_vm.actualLanguage]))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [(_vm.ListOfSharings.length > 0) ? _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelReferenceName[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelSharingName[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelRecipient[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelStatus[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.ListOfSharings), function(sharing, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [(sharing.sharedEntity.entityType === 'Channel') ? _c('i', {
      staticClass: "fa fa-television fa-2x push-5-r "
    }) : _vm._e(), _vm._v(" "), (sharing.sharedEntity.entityType === 'Device') ? _c('i', {
      staticClass: "fa fa-server fa-2x push-5-r "
    }) : _vm._e(), _vm._v(" "), (sharing.sharedEntity.entityType === 'Bundle') ? _c('i', {
      staticClass: "fa fa-usb fa-2x push-5-r "
    }) : _vm._e(), _vm._v(" "), (sharing.sharedEntity.entityType === 'Group') ? _c('i', {
      staticClass: "fa fa-users fa-2x push-5-r "
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('p', [_vm._v(_vm._s(sharing.sharedEntity.entityReferenceName))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('p', [_vm._v(_vm._s(sharing.sharingReferenceName))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('p', [_vm._v(_vm._s(sharing.guessEmail))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(sharing.sharingStatus == 'Activated') ? _c('button', {
      staticClass: "btn btn-xs btn-success",
      attrs: {
        "type": "button",
        "name": "button"
      }
    }, [_vm._v(_vm._s(_vm.tableStatusLabelActivated[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (sharing.sharingStatus == 'Rejected') ? _c('button', {
      staticClass: "btn btn-xs btn-danger",
      attrs: {
        "type": "button",
        "name": "button"
      }
    }, [_vm._v(_vm._s(_vm.tableStatusLabelRejected[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (sharing.sharingStatus == 'Pending') ? _c('button', {
      staticClass: "btn btn-xs btn-info",
      attrs: {
        "type": "button",
        "name": "button"
      }
    }, [_vm._v(_vm._s(_vm.tableStatusLabelWaiting[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (sharing.sharingStatus == 'OnHold') ? _c('button', {
      staticClass: "btn btn-xs btn-warning",
      attrs: {
        "type": "button",
        "name": "button"
      }
    }, [_vm._v(_vm._s(_vm.tableStatusLabelPause[_vm.actualLanguage]))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn btn-xs btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Modifier/Edit"
      },
      on: {
        "click": function($event) {
          return _vm.editSharingRulePermissions(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]), _vm._v(" "), (sharing.sharingStatus == 'Activated') ? _c('button', {
      staticClass: "btn btn-xs btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Pause"
      },
      on: {
        "click": function($event) {
          return _vm.saveSharingStatus(index, 'OnHold')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pause"
    })]) : _vm._e(), _vm._v(" "), (sharing.sharingStatus == 'OnHold') ? _c('button', {
      staticClass: "btn btn-xs btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Activer/Enable"
      },
      on: {
        "click": function($event) {
          return _vm.saveSharingStatus(index, 'Activated')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-play"
    })]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Supprimer/Delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteSharing(index, 'Deleted')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])])
  }), 0)]) : _vm._e()])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-tabs-alt nav-justified",
    attrs: {
      "data-toggle": "tabs"
    }
  }, [_c('li', {
    class: {
      'active': _vm.tabMenuSelector[2] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(2)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-server"
  }), _vm._v(" " + _vm._s(_vm.tabLabelModule[_vm.actualLanguage]))])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tabMenuSelector[3] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(3)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-television"
  }), _vm._v(" " + _vm._s(_vm.tabLabelDevice[_vm.actualLanguage]))])]), _vm._v(" "), (false) ? _c('li', {
    class: {
      'active': _vm.tabMenuSelector[4] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(4)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-bell"
  }), _vm._v(" " + _vm._s(_vm.tabLabelAlert[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), (_vm.profileData.profileConfig.displayEvConfig.value) ? _c('li', {
    class: {
      'active': _vm.tabMenuSelector[5] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(5)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-car"
  }), _vm._v(" " + _vm._s(_vm.tabLabelEV[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), (_vm.flagConfigCustomDashboard) ? _c('li', {
    class: {
      'active': _vm.tabMenuSelector[6] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(6)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" " + _vm._s(_vm.tabLabelCustomDashboard[_vm.actualLanguage]))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "block-content tab-content"
  }, [_c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[2] == true
    }
  }, [_vm._l((_vm.actualBundle.devices), function(device, index) {
    return _c('div', [(device.DeviceData.frontendComponents.componentDeviceConfig === 'EVA_V1P00') ? _c('config-device', {
      attrs: {
        "deviceIndex": index
      }
    }) : _vm._e(), _vm._v(" "), (device.DeviceData.frontendComponents.componentDeviceConfig === 'ApiDevice_V1P00') ? _c('config-device-api-dev-v1p00', {
      attrs: {
        "deviceIndex": index
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn  btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showModal('add-device-form')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-server fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddDevice[_vm.actualLanguage]))])])], 2), _vm._v(" "), _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[3] == true
    }
  }, [(_vm.displayChannelList === true) ? _c('div', [_c('config-channel-list')], 1) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addChannelToBundle()
      }
    }
  }, [(_vm.channelIsCreating) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-television fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddChannel[_vm.actualLanguage]))])], 1)])])]), _vm._v(" "), (false) ? _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[4] == true
    }
  }, [_c('h4', {
    staticClass: "font-w300 push-15"
  }, [_vm._v("Alertes")]), _vm._v(" "), _c('p', [_vm._v("...")])]) : _vm._e(), _vm._v(" "), (_vm.profileData.profileConfig.displayEvConfig.value) ? _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[5] == true
    }
  }, [_vm._l((_vm.actualBundle.cars), function(car, index) {
    return _c('div', [_c('config-car', {
      attrs: {
        "carIndex": index
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addCarToBundle()
      }
    }
  }, [(_vm.carIsCreating) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-car fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddCar[_vm.actualLanguage]))])], 1)])])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[6] == true
    }
  }, [_c('config-custom-dashboard')], 1)])])])]) : _c('div', [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-tabs-alt nav-justified",
    attrs: {
      "data-toggle": "tabs"
    }
  }, [(_vm.actualBundleIsDefaultBundle == false) ? _c('li', {
    class: {
      'active': _vm.tabMenuSelector[0] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(0)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" " + _vm._s(_vm.tabLabelGroup[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tabMenuSelector[1] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(1)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-usb"
  }), _vm._v(" " + _vm._s(_vm.tabLabelSystem[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.actualBundle.sub_bundle.length) ? _c('li', {
    class: {
      'active': _vm.tabMenuSelector[2] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(2)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-usb"
  }), _vm._v(" " + _vm._s(_vm.tabLabelSubSystem[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tabMenuSelector[3] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(3)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-server"
  }), _vm._v(" " + _vm._s(_vm.tabLabelModule[_vm.actualLanguage]))])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tabMenuSelector[4] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(4)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-television"
  }), _vm._v(" " + _vm._s(_vm.tabLabelDevice[_vm.actualLanguage]))])]), _vm._v(" "), (false) ? _c('li', {
    class: {
      'active': _vm.tabMenuSelector[5] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(5)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-bell"
  }), _vm._v(" " + _vm._s(_vm.tabLabelAlert[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), (_vm.profileData.profileConfig.displayEvConfig.value) ? _c('li', {
    class: {
      'active': _vm.tabMenuSelector[6] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(6)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-car"
  }), _vm._v(" " + _vm._s(_vm.tabLabelEV[_vm.actualLanguage]))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "block-content tab-content"
  }, [(_vm.actualBundleIsDefaultBundle == false) ? _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[0] == true
    }
  }, [_c('config-group')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[1] == true
    }
  }, [_c('config-bundle')], 1), _vm._v(" "), _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[2] == true
    }
  }, [_vm._l((_vm.actualBundle.sub_bundle), function(subBundle, index) {
    return _c('div', [_c('config-sub-bundle', {
      attrs: {
        "subBundleIndex": index
      }
    })], 1)
  }), _vm._v(" "), _vm._m(2)], 2), _vm._v(" "), _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[3] == true
    }
  }, [(_vm.bundleConfigEditFlag) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('config-sharing-list', {
    attrs: {
      "sharingListData": {
        sharingType: 'Device'
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.actualBundle.devices), function(device, index) {
    return _c('div', [(device.DeviceData.frontendComponents.componentDeviceConfig === 'EVA_V1P00') ? _c('config-device', {
      attrs: {
        "deviceIndex": index
      }
    }) : _vm._e(), _vm._v(" "), (device.DeviceData.frontendComponents.componentDeviceConfig === 'ApiDevice_V1P00') ? _c('config-device-api-dev-v1p00', {
      attrs: {
        "deviceIndex": index
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn  btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showModal('add-device-form')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-server fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddDevice[_vm.actualLanguage]))])])], 2), _vm._v(" "), _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[4] == true
    }
  }, [(_vm.displayChannelList === true) ? _c('div', [_c('config-channel-list')], 1) : _vm._e(), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addChannelToBundle()
      }
    }
  }, [(_vm.channelIsCreating) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-television fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddChannel[_vm.actualLanguage]))])], 1)])])]), _vm._v(" "), (false) ? _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[5] == true
    }
  }, [_c('h4', {
    staticClass: "font-w300 push-15"
  }, [_vm._v("Alertes")]), _vm._v(" "), _c('p', [_vm._v("...")])]) : _vm._e(), _vm._v(" "), (_vm.profileData.profileConfig.displayEvConfig.value) ? _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[6] == true
    }
  }, [(_vm.bundleConfigEditFlag) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('config-sharing-list', {
    attrs: {
      "sharingListData": {
        sharingType: 'Car'
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.actualBundle.cars), function(car, index) {
    return _c('div', [_c('config-car', {
      attrs: {
        "carIndex": index
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addCarToBundle()
      }
    }
  }, [(_vm.carIsCreating) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-car fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddCar[_vm.actualLanguage]))])], 1)])])], 2) : _vm._e()])])])])]) : _vm._e()])]), _vm._v(" "), _c('h6', {
    staticClass: "font-w300 push-15"
  }, [_c('font', {
    attrs: {
      "size": "2",
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.test))])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73d7efb6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/Index.vue
// module id = 1551
// module chunks = 4